jQuery(document).ready(function(){

    //Subs hero block
    let subsHero = jQuery('.subs-hero-block');

    //Check subs hero exists on the page
    if (subsHero){

        let subsHeroMobBG = subsHero.attr('data-background-image');
        let subsHeroDesktopBG = subsHero.css('background-image');
        let screenSize = 767;

        if (jQuery(window).width() < screenSize){
            subsHero.attr('data-background-image', subsHeroDesktopBG);
            subsHero.css('background-image', 'url(' + subsHeroMobBG + ')');
        }else{
            subsHero.attr('data-background-image', subsHeroMobBG);
            subsHero.css('background-image', subsHeroDesktopBG);
        }

        jQuery(window).on('resize', function(){
            if (jQuery(window).width() < screenSize){
                subsHero.attr('data-background-image', subsHeroDesktopBG);
                subsHero.css('background-image', 'url(' + subsHeroMobBG + ')');
            }else{
                subsHero.attr('data-background-image', subsHeroMobBG);
                subsHero.css('background-image', subsHeroDesktopBG);
            }
        });

    }

})